import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import type { IDockviewHeaderActionsProps } from 'dockview';

interface TabAddButtonProps extends IDockviewHeaderActionsProps {
  onAddClick: () => void;
}

export const TabAddButton: React.FC<TabAddButtonProps> = ({ onAddClick }) => {
  return (
    <Tooltip title="Add/Switch Panel (Ctrl+K)">
      <IconButton
        size="small"
        onClick={onAddClick}
        sx={{
          width: 32,
          height: 32,
          padding: 0.5,
        }}
      >
        <AddIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};
